/* @flow strict */

import * as React from 'react';
import ReactDOM from 'react-dom';

type PropsType = {
  handleSave: () => void
};

class SaveBtn extends React.Component<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.navbarActionEl = document.querySelector('.topNavBarActions');
    this.navbarActionElNext = document.querySelector('.topNavBarActions + div');
  }

  componentDidMount = () => {
    this.navbarActionEl.style.display = 'flex';
    this.navbarActionElNext.style.display = 'none';
  }

  componentWillUnmount = () => {
    this.navbarActionEl.style.display = 'none';
    this.navbarActionElNext.style.display = 'flex';
  }

  render = (): React.Element<'button'> => {
    const Component = (
      <button className="btn btn-pink saveBtnSelfCheckin" onClick={this.props.handleSave}>
        <span>Save</span>
      </button>
    );

    return ReactDOM.createPortal(
      Component,
      this.navbarActionEl
    );
  }
}

export default SaveBtn;
